import React from "react";

const BAND_FIVE_ROLES = new Set(["RN", "RM", "RMN", "RNLD", "RSCN"]);
const HCA_ROLES = new Set(["HCA2", "HCA3"]);
const DOCTOR_ROLES = new Set(["LDOC", "LCON"]);

const roleClassName = (role) => {
  if (BAND_FIVE_ROLES.has(role)) return "medical-role-pill-band-five";
  if (HCA_ROLES.has(role)) return "medical-role-pill-hca";
  if (DOCTOR_ROLES.has(role)) return "medical-role-pill-doctor";
  if (role === "N/A") return "medical-role-pill-unset";
  return "medical-role-pill-misc";
};

const normaliseRoles = (roles) => {
  const values = Array.isArray(roles) ? roles : `${roles || ""}`.split(",");
  return values.map((role) => role.trim()).filter(Boolean);
};

export const MedicalRolePills = ({ roles, className = "" }) => {
  const medicalRoles = normaliseRoles(roles);
  if (medicalRoles.length === 0) return null;

  return (
    <span className={`medical-role-pills ${className}`.trim()}>
      {medicalRoles.map((role) => (
        <span key={role} className={`medical-role-pill ${roleClassName(role)}`}>
          {role}
        </span>
      ))}
    </span>
  );
};
